import styled from 'styled-components';

export const SeparatorStyled = styled.div<{
  orientation: 'horizontal' | 'vertical';
  disabled?: boolean;
}>`
  flex-grow: 0;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.resizablePanel?.dividerBg || '#e0e0e0'};
  user-select: none;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  touch-action: none;
  cursor: ${({ orientation, disabled }) =>
    disabled ? 'default' : orientation === 'horizontal' ? 'col-resize' : 'row-resize'};

  ${({ orientation }) =>
    orientation === 'horizontal'
      ? `
    width: 2px;
    height: 100%;
    min-width: 2px;
    padding: 0 3px;
    margin: 0 -3px;
  `
      : `
    height: 2px;
    width: 100%;
    min-height: 2px;
    padding: 3px 0;
    margin: -3px 0;
  `}
`;
